'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);

var PatternParam = /*#__PURE__*/function () {
  function PatternParam(paramName, isSet, elementType, vertexType) {
    _classCallCheck__default["default"](this, PatternParam);
    this.paramName = paramName;
    this.isSet = isSet;
    this.elementType = elementType;
    this.vertexType = vertexType;
  }

  /**
   * Check if two parameters can happen together.
   * If two parameter names are not same, that's fine.
   * If two parameter names are same, they must have same data type.
   *
   * @param {PatternParam} other
   * @returns {boolean}
   * @memberof PatternParam
   */
  return _createClass__default["default"](PatternParam, [{
    key: "isCompatible",
    value: function isCompatible(other) {
      return this.paramName !== other.paramName || this.getTypeDef() === other.getTypeDef();
    }

    /**
     * Get the parameter definition string.
     *
     * @returns {string}
     * @memberof PatternParam
     */
  }, {
    key: "toString",
    value: function toString() {
      var _context;
      return _concatInstanceProperty__default["default"](_context = "".concat(this.getTypeDef(), " ")).call(_context, this.paramName);
    }

    /**
     * Get the parameter type definition.
     *
     * @returns {string}
     * @memberof PatternParam
     */
  }, {
    key: "getTypeDef",
    value: function getTypeDef() {
      var type = this.elementType + (this.vertexType ? "<".concat(this.vertexType, ">") : '');
      if (this.isSet) {
        type = "set<".concat(type, ">");
      }
      return type;
    }

    /**
     * Get the human-readble description of the data type.
     *
     * @returns {string}
     * @memberof PatternParam
     */
  }, {
    key: "getTypeDescription",
    value: function getTypeDescription() {
      switch (this.elementType) {
        case 'vertex':
          {
            return "".concat(this.vertexType, " vertex");
          }
        default:
          {
            return this.elementType;
          }
      }
    }
  }]);
}();

exports.PatternParam = PatternParam;
